import { createStore, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';
import { composeWithDevTools } from 'redux-devtools-extension/developmentOnly';
import { browserHistory } from 'react-router';
import { routerMiddleware  } from 'react-router-redux';
import reducer from './reducer';

const loggerMiddleware = storeAPI => next => action => {
	console.log('dispatching', action);
	let result = next(action);
	console.log('next state', storeAPI.getState());
	return result;
};

const middlewares = [
	thunk,
	routerMiddleware(browserHistory),
	process.env.NODE_ENV === 'development' ? loggerMiddleware : null
].filter(Boolean);

// pass object to configure this, options like actionSanitizer, stateSanitizer
const composeEnhancers = composeWithDevTools;

const store = createStore(reducer, composeEnhancers(
	applyMiddleware(...middlewares)
));

if (process.env.NODE_ENV === 'development') {

	if (module.hot) {
		module.hot.accept('./reducer', () => store.replaceReducer(reducer));
	}
}

export default store;



// WEBPACK FOOTER //
// ./frontend/cabinets/apps/everad/store.js